// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Hleb Serafimovich <hleb.serafimovich@celadon.ae>

import * as types from './actionTypes';


export function requestArrangeCollection(orderId) {
  return {
    type: types.ARRANGE_COLLECTION_REQUEST,
    orderId,
  };
}

export function startLoader() {
  return {
    type: types.ARRANGE_COLLECTION_START_LOADER,
  };
}

export function stopLoader() {
  return {
    type: types.ARRANGE_COLLECTION_STOP_LOADER,
  };
}

export function setStatus(payload) {
  return {
    type: types.ARRANGE_COLLECTION_SET_STATUS,
    payload,
  };
}

export function setFieldForTradeCustomer1(field, value) {
  return {
    type: types.SET_FIELD_FOR_TRADE_CUSTOMER_1,
    field,
    value,
  };
}

export function setFieldForTradeCustomer2(field, value) {
  return {
    type: types.SET_FIELD_FOR_TRADE_CUSTOMER_2,
    field,
    value,
  };
}

export function bookCollectionForTrade1(data) {
  return {
    type: types.BOOK_COLLECTION_FOR_TRADE_1,
    data,
  };
}

export function bookCollectionForTrade1Success() {
  return {
    type: types.BOOK_COLLECTION_FOR_TRADE_1_SUCCESS,
  };
}

export function bookCollectionForTrade2(data) {
  return {
    type: types.BOOK_COLLECTION_FOR_TRADE_2,
    data,
  };
}

export function bookCollectionForTrade2Success() {
  return {
    type: types.BOOK_COLLECTION_FOR_TRADE_2_SUCCESS,
  };
}

export function validatePhoneNumber(data, dataForNextRequest) {
  return {
    type: types.VALIDATE_PHONE_NUMBER,
    data,
    dataForNextRequest,
  };
}
export function validatePhoneNumberFailed(error) {
  return {
    type: types.VALIDATE_PHONE_NUMBER_FAILED,
    error,
  };
}

export function resetError() {
  return {
    type: types.RESET_ERROR,
  };
}

export function setIsButtonPressed(isButtonPressed) {
  return {
    type: types.SET_IS_BUTTON_PRESSED,
    isButtonPressed,
  };
}
